import axios from 'axios'

class studentService {
  getStudent(token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/students`, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentByAirforceId(airforceId, majorCourseName, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/students/find/${airforceId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ majorCourseName }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentByUnit(unit, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/students/find/units/${unit}`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentByUnitSpcNo(unitSpcNo, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/students/find/unitScps/${unitSpcNo}`,
        {
          method: 'GET',
          headers: {
            token: token,
          },
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  updateStudentEclScore(id, score, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/v1/students/${id}/updateScore`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            token: token,
          },
          body: JSON.stringify({ score }),
        },
      )
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  getStudentById(id, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/students/${id}`, {
        method: 'GET',
        headers: {
          token: token,
        },
      })
        .then((data) => resolve(data.json()))
        .catch((err) => reject(err))
    })
  }

  updateStudentFile(id, data, token) {
    return new Promise(async (resolve, reject) => {
      const request = new FormData()
      request.append('field', data.name)
      request.append('file', data.file)
      axios
        .patch(
          `${process.env.REACT_APP_BACKEND_URL}api/v1/students/${id}/updateFile`,
          request,
          { headers: { token: token } },
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export default studentService
